import hash from 'object-hash';
import _ from 'lodash';
import { Commit } from 'vuex';
import { CancelTokenSource } from 'axios';
import { END_LOADING, SET_CANCEL_TOKEN, SET_PROPS, START_LOADING } from '@/main/store/listEditTypes';
import { PageStoreBase, PageStoreProps } from '@/main/store/@types/page';
import { Table } from '@/main/utils/table';

export const mutations = {
	updateField(state: PageStoreBase, { path, value }: { path: string, value: any }) {
		path.split(/[.[\]]+/).reduce((prev: any, key: string, index: number, array: any[]) => {
			if (array.length === index + 1) {
				// eslint-disable-next-line no-param-reassign
				prev[key] = value;
			}

			return prev[key];
		}, state);
	},

	[SET_PROPS](state: PageStoreBase, props: PageStoreProps) {
		_.assign(state.props, props);
	},

	[SET_CANCEL_TOKEN](state: PageStoreBase, { cancelTokenKey, token }: { cancelTokenKey: string, token: CancelTokenSource }) {
		const currentToken = state.requestCancelTokens[cancelTokenKey];

		currentToken && !_.isNil(currentToken.cancel) && currentToken.cancel();

		state.requestCancelTokens[cancelTokenKey] = token;
	},


	[START_LOADING](state: PageStoreBase) {
		state.loadingCount += 1;
	},

	[END_LOADING](state: PageStoreBase) {
		state.loadingCount -= 1;
	},

	beforeRefresh(state: PageStoreBase) {},

	destroy(this: { commit: Commit }, state: PageStoreBase, storeUri: string) {
		Object.keys(state.requestCancelTokens).forEach((cancelTokenKey) => {
			this.commit(`pages/${storeUri}/${SET_CANCEL_TOKEN}`, { cancelTokenKey, token: null });
		});
	},

	updateTableHash(state: PageStoreBase, { uri = 'table' }) {
		const table = _.get(state, uri) as Table;
		table.hash = hash(table.rows);
	},
};
